import React, { useEffect, useState } from 'react';
import { VehicleItem } from '../../services/api/types';
import { FormCard } from './FormCard';
import { JsonFormsCore } from '@jsonforms/core';

import vehicleUiSchema from './forms/schemas/vehicle/uischema.json';

export interface VehicleContextProps {
  data: VehicleItem;
  onSave(data: any): void;
  onChange?(state: Pick<JsonFormsCore, 'data' | 'errors'>): void;
  vehicleSchema: any;
}

export const Vehicle = ({
  onSave,
  data,
  onChange,
  vehicleSchema,
}: VehicleContextProps) => {
  const [isEdit, setEditState] = useState(false);
  const [props, setProps] = useState<any>(data);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [isvalid, setIsvalid] = useState<boolean>(false);

  useEffect(() => {
    if (data.year === '0' || data.year === undefined) {
      data.year = 'None';
    }
  });

  const editHandler = (state: boolean) => {
    if (state && !isvalid) {
      setFormSubmitted(true);
    } else {
      setFormSubmitted(false);
    }
    setEditState(state);
  };

  const _changeHandler = (state: Pick<JsonFormsCore, 'data' | 'errors'>) => {
    let valid = true;
    if (state && state.errors && state.errors.length) {
      valid = false;
    }
    if (state.data) {
      setProps(state.data);
    }
    if (onChange) {
      onChange(state);
    }
    setIsvalid(valid);
  };
  const saveHandler = (vehicleData: any) => {
    if (onSave) {
      setFormSubmitted(true);
      onSave(vehicleData);
      setFormSubmitted(false);
    }
    setEditState(false);
  };
  const onKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      setFormSubmitted(true);
      if (isvalid) {
        saveHandler(props);
      }
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form onKeyUp={onKeyPress}>
      <div
        className={`${formSubmitted ? 'formSubmitted' : ''} ${
          isvalid ? 'isvalid' : 'notvalid'
        }`}
      >
        <FormCard
          data={data}
          title="Vehicle"
          onSave={saveHandler}
          uischema={vehicleUiSchema}
          schema={vehicleSchema}
          onEdit={editHandler}
          onChange={_changeHandler}
          isReadonly={isEdit ? false : true}
        />
      </div>
    </form>
  );
};
